import { fmtDate } from '../../lib/format';
import type { PortalMilestone, PortalMilestoneId } from './api';

// Milníky výroby z pohledu klienta (portál zakázky). Interní fáze se ven
// neposílají — viz backend/src/services/portalMilestones.ts.
export const MILESTONE_META: Record<PortalMilestoneId | 'cancelled', { label: string; badge: string }> = {
  prijato: { label: 'Zadání přijato', badge: 'bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300' },
  navrh: { label: 'Návrh hotový', badge: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300' },
  vyroba: { label: 'Ve výrobě', badge: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' },
  pripraveno: { label: 'Připraveno k předání', badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300' },
  predano: { label: 'Předáno', badge: 'bg-emerald-600 text-white dark:bg-emerald-500 dark:text-emerald-950' },
  cancelled: { label: 'Zrušeno', badge: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300' },
};

export function MilestoneBadge({ milestone }: { milestone: PortalMilestone }) {
  const meta = MILESTONE_META[milestone.current];
  return <span className={`shrink-0 rounded px-2 py-0.5 text-xs font-medium ${meta.badge}`}>{meta.label}</span>;
}

export default function MilestoneSteps({ milestone }: { milestone: PortalMilestone }) {
  if (milestone.current === 'cancelled') return null;
  const steps = milestone.steps;
  return (
    <ol className="mt-3 grid grid-cols-5" aria-label="Průběh výroby">
      {steps.map((s, i) => {
        const isCurrent = s.id === milestone.current;
        const nextReached = steps[i + 1]?.reached;
        return (
          <li key={s.id} className="relative flex flex-col items-center text-center" aria-current={isCurrent ? 'step' : undefined}>
            {/* Spojnice k dalšímu milníku */}
            {i < steps.length - 1 && (
              <span
                aria-hidden
                className={`absolute left-1/2 top-[7px] h-0.5 w-full ${nextReached ? 'bg-emerald-500' : 'bg-zinc-200 dark:bg-zinc-700'}`}
              />
            )}
            <span
              aria-hidden
              className={`relative z-10 h-4 w-4 rounded-full border-2 ${
                s.reached
                  ? 'border-emerald-500 bg-emerald-500'
                  : 'border-zinc-300 bg-white dark:border-zinc-600 dark:bg-zinc-900'
              } ${isCurrent ? 'ring-4 ring-emerald-500/20' : ''}`}
            />
            <span className={`mt-1.5 px-0.5 text-[11px] leading-tight ${s.reached ? 'text-zinc-800 dark:text-zinc-200' : 'text-zinc-400'} ${isCurrent ? 'font-semibold' : ''}`}>
              {MILESTONE_META[s.id].label}
            </span>
            {s.at && <span className="text-[10px] text-zinc-400">{fmtDate(s.at)}</span>}
          </li>
        );
      })}
    </ol>
  );
}
